import React from 'react'

const SvgSemaphoreNegativeColor = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 110 110"
        {...props}
    >
        <defs>
            <linearGradient
                id="semaphore_negative_color_svg__a"
                x1={93.89}
                y1={93.89}
                x2={16.11}
                y2={16.11}
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0} stopColor="#c31003" />
                <stop offset={1} stopColor="#f3444a" />
            </linearGradient>
            <linearGradient
                id="semaphore_negative_color_svg__b"
                x1={38.77}
                y1={39.49}
                x2={71.23}
                y2={71.95}
                gradientUnits="userSpaceOnUse"
            >
                <stop offset={0} stopColor="#fff" stopOpacity={0} />
                <stop offset={1} stopColor="#1e0006" />
            </linearGradient>
        </defs>
        <g
            data-name="Vrstva 2"
            style={{
                isolation: "isolate",
            }}
        >
            <circle
                cx={55}
                cy={55}
                r={55}
                style={{
                    fill: "url(#semaphore_negative_color_svg__a)",
                }}
            />
            <image
                width={66}
                height={32}
                transform="translate(22.35 40.24)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEMAAAAhCAYAAACC9hYiAAAACXBIWXMAAAsSAAALEgHS3X78AAACnklEQVRoQ+2Zb0/cMAyHnxzlYDchxiaBNmnf/7NtL0ATu6Pcv+yFbdVJ05ZXLD3uJ0W9lhLFT203dkOMkbNEzdQNIYSQXyreWJeSJxzf+MRD6T4F4AfZ7zko0kGx33EMTALDQVgAF9kxh1OzohtH4JAdi1DyMAmI8Q2wdKMhhVK7PIQ9sHVjr9eHYahXLPTaNfBZx0rPlwgQHza1yYfFATG+BTbAWkcLxBBCzzu8Z5hXLBEIX4A7HTcIkEsEmN1fm8y4I7BDDH8GnnTY32yMwljQwbgDvgMPwFe9dkX9oWIh8op4wiPyIEEAvSIe07OhgSRxmmesEBgPwE/gHrhFJvWhUqMsRFrgD/IQ0fO/Oi4Qs4MPlTyB+pxxg3jEPfADgbOig1EjEHuDHJA8YSC8hzR0oZ4oDxPvHZZEbxEQ3xAYg5NVoiPyxvik52vEjvwlUA4TVb7HuERyxDUCYYVM2lC/Z+z1/AVZ/xViT75nSmQw/OvSQzEwtvdokElrBGGyHGB7IwNQ2jgGd/9kbZLDCfQnrElmWGm9kxqK/XyCMHCsTWPrnIRScyJ8d51hOA3B8OWvnZeOtWlsnblNPU0l0LwU9hPWDCRf75vWajC8gX4yK4OtFLb392Qy+k/y+wwr1a2HUYKTQPKe4SEc6IoaK4FtRzeXHehGR4vYscM1dyh4SwmG7wOsSYudF+ZVmzwh67c+xpausTMKAzqq1gd4JC125li1/kbseNZre8TOnhqAGGMMIXivMKrWB7BiZ679jF+IPRucd4x1umySrU5inaGWrvyde6drjdjX63JBH4Z5xlqv7ZBmyCn1QH3eSJR/KrAq9eS74zHGXt7IE6gR9SFzkt9NSv90/qLmVISR3PDRv7V+VNW8rX53nWE4/QOOhj++nOirHAAAAABJRU5ErkJggg=="
                style={{
                    mixBlendMode: "soft-light",
                }}
            />
            <path
                style={{
                    fill: "#fff",
                }}
                d="M30.06 48.19h49.88v15.06H30.06z"
            />
            <path
                style={{
                    opacity: 0.25,
                    fill: "url(#semaphore_negative_color_svg__b)",
                }}
                d="M30.06 48.19h49.88v15.06H30.06z"
            />
        </g>
    </svg>
);

export default SvgSemaphoreNegativeColor;